import alertDictionaries from './dictionaries'

export default $alert => {
  const getForm = () => $alert.form
  const getOpenModal = () => $alert.openModal
  const getOpenExitModal = () => $alert.openExitModal
  const getDictionaries = () => alertDictionaries

  return { getForm, getOpenModal, getOpenExitModal, getDictionaries }
}
